import { render, staticRenderFns } from "./workouts.vue?vue&type=template&id=36b9a46c&"
import script from "./workouts.vue?vue&type=script&lang=js&"
export * from "./workouts.vue?vue&type=script&lang=js&"
import style0 from "./workouts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports